import { render, staticRenderFns } from "./BoletimMedicaoForm.vue?vue&type=template&id=56dd4fb4&"
import script from "./BoletimMedicaoForm.vue?vue&type=script&lang=js&"
export * from "./BoletimMedicaoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports